
import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import NewBanner from "@/components/sections/NewBanner";
import NewSectionTwo from "@/components/sections/NewSectionTwo";
import SectionThree from "@/components/sections/SectionThree";
import MeineVision from "@/components/sections/MeineVision";
import NextSteps from "@/components/sections/NextSteps";
import NewSectionFive from "@/components/sections/NewSectionFive";
import NewSectionSix from "@/components/sections/NewSectionSix";
import NewSectionSeven from "@/components/sections/NewSectionSeven";
import { AdminSection } from "@/components/admin/AdminSection";
import { useLocation } from "react-router-dom";
import { useAuthSession } from "@/hooks/useAuthSession";
import { useOgImage } from "@/hooks/useOgImage";

const Index = () => {
  const location = useLocation();
  const { session } = useAuthSession();
  const { checkImageExists, fullOgImageUrl } = useOgImage();

  // Handle scroll to section from location state
  useEffect(() => {
    if (location.state?.scrollToId) {
      const element = document.getElementById(location.state.scrollToId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  // Periodically check if OG image exists for admins
  useEffect(() => {
    const verifyOgImage = async () => {
      const urlToCheck = fullOgImageUrl;
      await checkImageExists(urlToCheck);
    };
    
    if (session) {
      verifyOgImage();
    }
    
    const interval = setInterval(() => {
      if (session) {
        verifyOgImage();
      }
    }, 30000);
    
    return () => clearInterval(interval);
  }, [session, fullOgImageUrl, checkImageExists]);

  return (
    <div className="min-h-screen bg-[#243949]">
      <Navigation />
      <section id="ns1">
        <NewBanner />
      </section>
      <div className="h-4 bg-[#9F9EA1]" />
      <section id="ns2">
        <NewSectionTwo />
      </section>
      <div className="h-4 bg-[#9F9EA1]" />
      <section id="ns3">
        <SectionThree />
      </section>
      <div className="h-4 bg-[#9F9EA1]" />
      <section id="ns4">
        <NewSectionFive />
      </section>
      <div className="h-4 bg-[#9F9EA1]" />
      <section id="ns5">
        <MeineVision />
      </section>
      <div className="h-4 bg-[#9F9EA1]" />
      <section id="ns6">
        <NewSectionSix />
      </section>
      <div className="h-4 bg-[#9F9EA1]" />
      <section id="ns7">
        <NewSectionSeven />
      </section>
      <div className="h-4 bg-[#9F9EA1]" />
      <NextSteps />

      <AdminSection />
    </div>
  );
};

export default Index;
